import {I18nUtils} from "../../../i18n/I18nUtils";
import {
  WORK_ADD_LOADING,
  WORK_ERROR, WORK_LOADING, WORK_UPDATE, WORKS_ERROR, WORKS_LOADING, WORKS_STATE_UPDATE,
  WORKS_UPDATE,
    WORK_CLEAR
} from "../actions/workActions";
import _ from 'lodash';

const INITIAL_STATE = {
  works: [],
  worksPagination: null,
  worksLoading: false,
  worksError: null,
  workStates: [
    {
      "id": 0,
      "name": I18nUtils.tr('TR_TODOS'),
    },
  ],
  workLoading: false,
  workError: null,
  workAddLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WORKS_STATE_UPDATE:
      return {
        ...state,
        workStates: [...INITIAL_STATE.workStates, ...action.payload.data],
      };
    case WORKS_UPDATE:
      return {
        ...state,
        works: _.mapKeys(action.payload.data, "id"),
        worksPagination: action.payload.pagination,
        worksError: action.payload.message,
      };
    case WORK_UPDATE:
      const work = action.payload.data;
      const works = {...state.workers, [work.id]: work};
      return { ...state, works: works };
    case WORKS_ERROR:
      return { ...state, worksError: action.payload };
    case WORKS_LOADING:
      return {...state, worksLoading: action.payload };
    case WORK_ERROR:
      return { ...state, workError: action.payload };
    case WORK_LOADING:
      return {...state, workLoading: action.payload };
    case WORK_ADD_LOADING:
      return {...state, workAddLoading: action.payload };
      case WORK_CLEAR:
          return {...state, ...INITIAL_STATE};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/works/reducers/WorksReducer.js